export const MAX_MILEAGE = 999_999_999.99;
export const MAX_TITLE = 50;
export const MIN_MILEAGE = 0.01;
export const MIN_TITLE = 1;

export const TITLE_ERROR_MESSAGE = "Title is required";
export const MILEAGE_ERROR_MESSAGE = "Mileage is required";
export const MILEAGE_DATE_ERROR_MESSAGE = "Mileage date is required";
export const MILEAGE_MIN_MAX_ERROR_MESSAGE = `Mileage must be from ${MIN_MILEAGE} to ${MAX_MILEAGE}`;
